import SelectSFServices from './SelectSFServices';
import GallerySimpleManager from './GallerySimpleManager';
import CommunityCardPreview from './CommunityCardPreview';

export default {
  'SelectSFServices': SelectSFServices,
  'GallerySimpleManager': GallerySimpleManager,
  'CommunityCardPreview': CommunityCardPreview
};
